// extracted by mini-css-extract-plugin
export default {"removePermissionButton":"removePermissionButton---jHNx3","removePermissionIcon":"removePermissionIcon---OTEPs"};